// Arama eşleştirme için Türkçe katlama: büyük harf + İ/I ve Ç/Ğ/Ş/Ö/Ü sadeleştirme ("hali" ↔ "HALI YIKAMA" eşleşir)
const MAP = { İ: "I", Ç: "C", Ğ: "G", Ş: "S", Ö: "O", Ü: "U" };
export const fold = (s) => String(s || "").toLocaleUpperCase("tr").replace(/[İÇĞŞÖÜ]/g, (c) => MAP[c]);
export const foldIncludes = (hay, needle) => fold(hay).includes(fold(needle));
